import { Dayjs } from "dayjs"
import {
  IFreshdeskConversation,
  IFreshdeskAttachment,
} from "./freshdeskThreadConversation.types"

function getIconFromType(fileType: string): string {
  const fileTypeParts = fileType.split("/")
  switch (fileTypeParts[0]?.toLowerCase()) {
    case "image":
      return "file-image"
    case "audio":
      return "file-music"
    case "video":
      return "file-video"
    case "text":
      return "file-text"
    case "pdf":
      return "file-text"
    default:
      return "file"
  }
}

export class FreshdeskAttachment implements IFreshdeskAttachment {
  name: string
  type: string
  path: string
  url: string

  constructor(name: string, type: string, path: string, url: string) {
    this.name = name
    this.type = type
    this.path = path
    this.url = url
  }

  get icon(): string {
    return getIconFromType(this.type)
  }
}

export class FreshdeskConversation implements IFreshdeskConversation {
  id: number
  description: string
  html: string
  isIncoming: boolean
  isPrivate: boolean
  createdDate: Dayjs
  toEmails: string[]
  attachments: IFreshdeskAttachment[]
  subject?: string
  fromEmail?: string

  constructor(
    id: number,
    description: string,
    html: string,
    isIncoming: boolean,
    isPrivate: boolean,
    createdDate: Dayjs,
    toEmails: string[],
    attachments: IFreshdeskAttachment[],
    subject: string,
    fromEmail: string,
  ) {
    this.id = id
    this.description = description
    this.html = html
    this.isIncoming = isIncoming
    this.isPrivate = isPrivate
    this.createdDate = createdDate
    this.toEmails = toEmails
    this.attachments = attachments
    this.subject = subject
    this.fromEmail = fromEmail
  }
}
